export default __webpack_public_path__ + "static/media/c001-ngo-4.60974a1c.jpg";